import "../css/Partners.css";
import scoreLoan from "../assets/scoreLoan.png";
import valueLeaf from "../assets/valueleaf.png";
import swipedLoan from "../assets/swipedLoan.png";
import spectrum from "../assets/spectrum-digital.png";
import bankSathi from "../assets/banksathi.png"


export default function Partners() {
  return (
    <section className="partners-section">

      <div className="section-tag">
        <span></span>
        <p>PARTNERS</p>
      </div>

      <h2>Shaping the future of fintech with top industry experts</h2>

      <p className="partner-text">
        We're growing from strength to strength with our credible partners.
      </p>

      <div className="partners-card">
        
          <img src={scoreLoan} alt="Score Loan" />
          <img src={valueLeaf} alt="Value Leaf" />
          <img src={swipedLoan} alt="Swiped Loan" />
          <img src={spectrum} alt="Spectrum-digital" />
          <img src={bankSathi} alt="BankSathi" />
          </div>
    
    </section>
  );
}